// extracted by mini-css-extract-plugin
export default {"requiredAsterisk":"FieldLabel_requiredAsterisk__3sOe7","required":"FieldLabel_required__fI1MV"};